import { Link } from "react-router-dom";

export default function ErrorPage() {
  return (
    <div className="container text-center mt-5">
      <h1>404</h1>
      <h4>Page Not Found</h4>
      <p>Please immediately check the URL or return to the Dashboard</p>

      <Link to="/" className="btn btn-primary mt-3">
        Go to Home
      </Link>
    </div>
  );
}
